/**
 * Script de suppression des logs [Cart Fix]
 * Ce script remplace la fonction console.log pour filtrer les logs sensibles
 */
(function() {
  // Attendre que le DOM soit chargé pour être sûr d'intercepter tous les logs
  document.addEventListener('DOMContentLoaded', function() {
    // Sauvegarder les fonctions de console originales
    const originalConsoleLog = console.log;
    const originalConsoleError = console.error;
    
    // Remplacer console.log pour filtrer les logs sensibles
    console.log = function(...args) {
      // Vérifier si le premier argument est une chaîne et contient "[Cart Fix]"
      if (args.length > 0 && 
          typeof args[0] === 'string' && 
          (args[0].includes('[Cart Fix]') || 
           args[0].includes('Cart Fix') ||
           args[0].includes('Ouverture manuelle du drawer'))) {
        // Ne pas afficher ce log
        return;
      }
      
      // Laisser passer les autres logs normalement
      originalConsoleLog.apply(console, args);
    };
    
    // Remplacer console.error pour filtrer les logs d'erreur sensibles
    console.error = function(...args) {
      // Vérifier si le premier argument est une chaîne et contient "[Cart Fix]"
      if (args.length > 0 && 
          typeof args[0] === 'string' && 
          args[0].includes('[Cart Fix]')) {
        // Ne pas afficher ce log d'erreur
        return;
      }
      
      // Laisser passer les autres logs d'erreur normalement
      originalConsoleError.apply(console, args);
    };
    
    // Intercepter la fonction customAddToCart si elle existe
    // Méthode 1: Si la fonction est déjà définie
    if (typeof window.customAddToCart === 'function') {
      interceptCartFunction();
    } else {
      // Méthode 2: Observer jusqu'à ce que la fonction soit définie
      // (utile si la fonction est définie après le chargement du DOM)
      let attempts = 0;
      const checkInterval = setInterval(function() {
        attempts++;
        if (typeof window.customAddToCart === 'function') {
          interceptCartFunction();
          clearInterval(checkInterval);
        } else if (attempts >= 50) {  // Arrêter après 50 tentatives (10 secondes)
          clearInterval(checkInterval);
        }
      }, 200);
    }
    
    function interceptCartFunction() {
      // Sauvegarder la fonction originale
      const originalCustomAddToCart = window.customAddToCart;
      
      // Remplacer par une version sans logs
      window.customAddToCart = function(form) {
        // Appeler silencieusement la fonction originale et renvoyer son résultat
        return originalCustomAddToCart.call(this, form);
      };
    }
  });
})();